module.exports = __webpack_public_path__ + "static/media/jaywan-logo.644a40c2.svg";